// UPI deep link helpers — opens GPay / PhonePe / Paytm / BHIM with amount pre-filled

export const buildUpiLink = ({ upi_id, host_name, amount, trip_name }) => {
  const params = new URLSearchParams({
    pa: upi_id,
    pn: host_name || 'TripLatch Host',
    am: String(amount),
    cu: 'INR',
    tn: `TripLatch-${(trip_name || 'Trip').replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 30)}`,
  });
  return `upi://pay?${params.toString()}`;
};
